import { render } from "./ModalDoQuiz.vue?vue&type=template&id=2bf5e79a"
import script from "./ModalDoQuiz.vue?vue&type=script&lang=js"
export * from "./ModalDoQuiz.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thuyninh/Sites/yamaha_lms_fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__